import {FormikProps} from 'formik';
import {IDirectDocsForm} from './formDetails';
import {ChangeEvent} from 'react';
import InputField from '../../../../../components/simpleInput';
import {ShowFormError} from '../../../../../utilities/helper/showFormError';

interface IProps {
  form: FormikProps<IDirectDocsForm>;
}

const LivingAddressInput = ({form}: IProps) => {
  return (
    <>
      <span className="block mt-4 font-medium text-gray-800 text-md">
        اطلاعات آدرس
      </span>

      <InputField
        name="livingAddress"
        label="آدرس محل سکونت"
        required
        placeholder="آدرس محل سکونت را وارد کنید"
        value={form.values.livingAddress || ''}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          form?.setFieldValue('livingAddress', e.target.value);
        }}
      />

      <ShowFormError field="livingAddress" form={form} />
    </>
  );
};

export default LivingAddressInput;
